import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import api from "../../services/api";

import Swal from "sweetalert2";

const CampaignList = (props) => {
    const [campaigns, setCampaigns] = useState([]);
    const [campaignsToShow, setCampaignsToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(function () {
        loadList();
    }, []);

    async function loadList() {
        setLoaded(false);

        const responseGetCampaigns = await api.get("/campaign");

        setCampaigns(responseGetCampaigns.data.data);
        setCampaignsToShow(responseGetCampaigns.data.data);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const originalCampaigns = campaigns;

        if (searchText === "") {
            setCampaignsToShow(originalCampaigns);
            setLoaded(true);
            return;
        }

        let filteredCampaigns = originalCampaigns.filter(
            (campaign) =>
                campaign.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) !== -1
        );

        if (filteredCampaigns.length <= 0) {
            filteredCampaigns = originalCampaigns.filter(
                (campaign) =>
                    campaign.name
                        .toLowerCase()
                        .indexOf(searchText.toLowerCase()) !== -1
            );
        }

        setCampaignsToShow(filteredCampaigns);
        setLoaded(true);
    }

    async function handleDelete(campaignDelete) {
        Swal.fire({
            title: `Tem certeza que deseja excluir a campanha ${campaignDelete.name}?`,
            text: "Não será possível voltar atrás!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero excluir!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (!result.value) {
                Swal.fire(
                    "Cancelado!",
                    "Nenhum dado será excluído.",
                    "success"
                );
            } else {
                setLoaded(false);

                try {
                    const responseDeleteCampaign = await api.delete(
                        `/campaign/${campaignDelete._id}`
                    );

                    if (responseDeleteCampaign.status === 204) {
                        const newCampaigns = campaigns.filter(
                            (campaign) => campaign._id !== campaignDelete._id
                        );
                        setCampaigns(newCampaigns);
                        setCampaignsToShow(newCampaigns);
                        setLoaded(true);
                    } else {
                        throw "Error";
                    }
                } catch (error) {
                    setLoaded(true);
                    Swal.fire({
                        type: "error",
                        title: "Oops...",
                        text:
                            "Tivemos um problema ao excluir essa campanha. Contate o suporte!",
                    });
                }
            }
        });
    }

    return (
        <Layout
            menuActive="registers"
            pageTitle="Lista de Campanhas"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Lista de Campanhas</div>
                            <ul className="card-action">
                                <li>
                                    <Link
                                        to="/campanhas/nova"
                                        className="btn btn-sm btn-success"
                                    >
                                        Novo <i className="fa fa-plus"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {campaignsToShow.map(
                                                (campaign, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {campaign.name}
                                                            </td>
                                                            <td>
                                                                <div className="col-xs-12">
                                                                    <div className="col-xs-12">
                                                                        <button
                                                                            className="btn btn-xs btn-danger"
                                                                            style={{
                                                                                width:
                                                                                    "100%",
                                                                            }}
                                                                            onClick={() =>
                                                                                handleDelete(
                                                                                    campaign
                                                                                )
                                                                            }
                                                                        >
                                                                            Excluir
                                                                            <div className="icon fa fa-trash-o"></div>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(CampaignList);
